import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {getUser} from "../../store/selectors";
import {connect} from "react-redux";
import Dashboard from "../../pages/Dashboard/Dashboard";
import Login from "../../pages/Login/Login";
import {API} from "../../http";
import Users from "../../pages/Users/Users";
import UserPreview from "../../pages/UserPreview/UserPreview";
import DayClose from "../../pages/DayClose/DayClose";
import CreatePayment from "../../pages/CreatePayment/CreatePayment";
import Tariffs from "../../pages/Tariffs/Tariffs";
import CreateCorporation from "../../pages/CreateCorporation/CreateCorporation";
import TransactionPreview from "../../pages/TransactionPreview/TransactionPreview";
import Ledger from "../../pages/Ledger/Ledger";
import Reports from "../../pages/Reports/Reports";

export const ROUTES = Object.freeze({
	DASHBOARD: {
		key: 'dashboard',
		path: '/admin/dashboard',
	},
	REPORTS: {
		key: 'reports',
		path: '/admin/reports',
	},
	LEDGER: {
		key: 'ledger',
		path: '/admin/ledger',
	},
	SIGN_IN: {
		key: 'login',
		path: '/auth/login',
	},
	USERS: {
		key: 'users',
		path: '/admin/users/list',
	},
	USER: {
		key: 'user',
		path: '/admin/users'
	},
	CLOSE_DAY: {
		key: 'close_day',
		path: '/admin/close_the_day'
	},
	CREATE_PAYMENT: {
		key: 'create_payment',
		path: '/admin/create_payment'
	},
	TARIFFS: {
		key: 'tariffs',
		path: '/admin/tariffs'
	},
	CREATE_CORPORATION: {
		key: 'corp_reg',
		path: '/admin/users/create_corp'
	},
	TRANSACTION: {
		key: 'transaction_view',
		path: '/admin/transaction'
	}
});
const authorizedRoutes = Object.freeze([
	{...ROUTES.DASHBOARD, element: <Dashboard/>},
	{...ROUTES.USERS, element: <Users/>},
	{...ROUTES.USER, path: `${ROUTES.USER.path}/:id`, element: <UserPreview/>},
	{...ROUTES.CLOSE_DAY, element: <DayClose/>},
	{...ROUTES.CREATE_PAYMENT, element: <CreatePayment/>},
	{...ROUTES.TARIFFS, element: <Tariffs/>},
	{...ROUTES.CREATE_CORPORATION, element: <CreateCorporation/>},
	{...ROUTES.TRANSACTION, path: `${ROUTES.TRANSACTION.path}/:id`, element: <TransactionPreview/>},
	{...ROUTES.LEDGER, element: <Ledger/>},
	{...ROUTES.REPORTS, element: <Reports/>},
]);
const unauthorizedRoutes = Object.freeze([
	{...ROUTES.SIGN_IN, element: <Login/>},
]);
const AppRouter = ({user}) => {
	return (
		<Routes>
			{Boolean(API.getKey() && user.authKey) ? (
				<React.Fragment>
					{authorizedRoutes.map(route => (
						<Route key={route.key} path={route.path} element={route.element} exact/>
					))}
					<Route path="*" element={<Navigate to={ROUTES.DASHBOARD.path}/>}/>
				</React.Fragment>

			) : (
				<React.Fragment>
					{unauthorizedRoutes.map(route => (
						<Route key={route.key} path={route.path} element={route.element} exact/>
					))}
					<Route path="*" element={<Navigate to={ROUTES.SIGN_IN.path}/>}/>
				</React.Fragment>
			)}
		</Routes>
	);
};

const mapStateToProps = state => ({
	user: getUser(state),
})
export default connect(mapStateToProps)(AppRouter);
